@if (systemaktivitet) {
  <div class="modal-body">
    <form id="formSystemaktivitet" [formGroup]="editForm" (ngSubmit)="save()">
      <div class="row">
        <div>
          <rask-datepicker label="fr.o.m" formControlName="datumFran" [required]="true"></rask-datepicker>
        </div>
        <div>
          <rask-datepicker label="t.o.m." formControlName="datumTill" [required]="true"></rask-datepicker>
        </div>
      </div>
      <div class="row">
        <rask-input class="col-12" label="Rubrik" infoText="Rubrik, visas på alla sidor" formControlName="rubrik"
        [required]="true"></rask-input>
      </div>
      <div class="row">
        <rask-textarea class="col-12" label="Meddelande" [rows]="9" [maxlength]="2000"
        infoText="Din meddelandetext" formControlName="meddelande" [required]="true"></rask-textarea>
      </div>
    </form>
  </div>
}
<div class="modal-footer">
  <rask-save-button form="formSystemaktivitet" click="save()" [disabled]="!editForm.valid"></rask-save-button>
  <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>{{commonTexts.cancel}}</rask-button>
</div>
